import { Locale } from 'modules/i18n';

const loggedIn = {
  description: `You've come to Ankr's Web3 API platform through a referral. This makes you eligible for a 20% increase on your first deposit if you choose to go Premium with us.`,
  invitationToSignIn: 'Activate to be able to redeem your bonus.',
  title: 'Referral activation',
};

export const referralGreetingTranslation = {
  [Locale.en]: {
    loggedIn,
    loggedOut: {
      description: loggedIn.description,
      invitationToSignIn:
        'Sign in to start testing premium features with Freemium.',
      title: 'Welcome to Web3 API platform',
    },
  },
};
